import styled from 'styled-components'

import { helpers } from 'styles'

import { Button } from './Button'

export const Container = styled.div`
	border-radius: 4px;
	border: 1px solid ${helpers.color.border};
	margin-top: 8px;

	${Button}:hover & {
		border-color: ${helpers.color.primaryAccent};
	}
`
